(function() {
  // Hide Shop Pay installment pre-qualifier (shows 'over £50' when price is below threshold)
  var style = document.createElement('style');
  style.textContent = 'shopify-payment-terms { display: none !important; }';
  document.head.appendChild(style);

  // Add trust badges below Add to Cart button
  function insertBadges() {
    var btn = document.querySelector('.product-form__buttons');
    if (!btn) return;
    var badges = document.createElement('div');
    badges.className = 'nuvora-trust-badges';
    badges.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px 18px;margin-top:14px;padding-top:14px;border-top:1px solid rgba(0,0,0,0.09);';
    var items = [
      ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', 'Secure Checkout'],
      ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', 'UK Based'],
      ['M22 11.08V12a10 10 0 1 1-5.93-9.14', 'Natural Ingredients'],
      ['M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z', '1,000+ Happy Customers']
    ];
    badges.innerHTML = items.map(function(i) {
      return '<div style="display:flex;align-items:center;gap:6px;font-size:13px;color:#555;">'
        + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2d7a50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="' + i[0] + '"/></svg>'
        + '<span>' + i[1] + '</span></div>';
    }).join('');
    btn.parentNode.insertBefore(badges, btn.nextSibling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertBadges);
  } else {
    insertBadges();
  }
})();
